import { render, staticRenderFns } from "./RuleStrategyConfig.vue?vue&type=template&id=af5fc292&scoped=true&"
import script from "./RuleStrategyConfig.vue?vue&type=script&lang=ts&"
export * from "./RuleStrategyConfig.vue?vue&type=script&lang=ts&"
import style0 from "./RuleStrategyConfig.vue?vue&type=style&index=0&id=af5fc292&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5fc292",
  null
  
)

export default component.exports